import { render, staticRenderFns } from "./SMSCampaignDetails.vue?vue&type=template&id=5019a28e&"
import script from "./SMSCampaignDetails.vue?vue&type=script&lang=ts&"
export * from "./SMSCampaignDetails.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports